// extracted by mini-css-extract-plugin
export var clauseRow = "_g6-6";
export var emptyState = "_g6-d";
export var filterContent = "_g6-a";
export var filterGroup = "_g6-1";
export var filterGroupContainer = "_g6-0";
export var nestedGroup = "_g6-2";
export var nestedGroupContent = "_g6-b";
export var nestedGroupDepth1 = "_g6-3";
export var nestedGroupDepth2 = "_g6-4";
export var nestedGroupDepth3 = "_g6-5";
export var nestedGroupEmpty = "_g6-c";
export var operatorAnd = "_g6-8";
export var operatorOr = "_g6-9";
export var operatorToggle = "_g6-7";
export var removeGroupButton = "_g6-e";